export const FETCH_PROVIDER_REQUESTS_REQUEST = 'FETCH_PROVIDER_REQUESTS_REQUEST';
export const FETCH_PROVIDER_REQUESTS_SUCCESS = 'FETCH_PROVIDER_REQUESTS_SUCCESS';
export const FETCH_PROVIDER_REQUESTS_FAILURE = 'FETCH_PROVIDER_REQUESTS_FAILURE';

export const FETCH_PROVIDER_REQUEST_DROPDOWNS_REQUEST = 'FETCH_PROVIDER_REQUEST_DROPDOWNS_REQUEST';
export const FETCH_PROVIDER_REQUEST_DROPDOWNS_SUCCESS = 'FETCH_PROVIDER_REQUEST_DROPDOWNS_SUCCESS';
export const FETCH_PROVIDER_REQUEST_DROPDOWNS_FAILURE = 'FETCH_PROVIDER_REQUEST_DROPDOWNS_FAILURE';

export const UPDATE_PROVIDER_REQUEST_STATUS_REQUEST = 'UPDATE_PROVIDER_REQUEST_STATUS_REQUEST';
export const UPDATE_PROVIDER_REQUEST_STATUS_SUCCESS = 'UPDATE_PROVIDER_REQUEST_STATUS_SUCCESS';
export const UPDATE_PROVIDER_REQUEST_STATUS_FAILURE = 'UPDATE_PROVIDER_REQUEST_STATUS_FAILURE';

export const BULK_UPDATE_PROVIDER_REQUEST_TASK_REQUEST = 'BULK_UPDATE_PROVIDER_REQUEST_TASK_REQUEST';
export const BULK_UPDATE_PROVIDER_REQUEST_TASK_SUCCESS = 'BULK_UPDATE_PROVIDER_REQUEST_TASK_SUCCESS';
export const BULK_UPDATE_PROVIDER_REQUEST_TASK_FAILURE = 'BULK_UPDATE_PROVIDER_REQUEST_TASK_FAILURE';

export const CHECK_PROVIDER_REQUEST_ADHOC_REQUEST = 'CHECK_PROVIDER_REQUEST_ADHOC_REQUEST';
export const CHECK_PROVIDER_REQUEST_ADHOC_SUCCESS = 'CHECK_PROVIDER_REQUEST_ADHOC_SUCCESS';
export const CHECK_PROVIDER_REQUEST_ADHOC_FAILURE = 'CHECK_PROVIDER_REQUEST_ADHOC_FAILURE';

export const SAVE_PROVIDER_REQUEST_ADHOC_REQUEST = 'SAVE_PROVIDER_REQUEST_ADHOC_REQUEST';
export const SAVE_PROVIDER_REQUEST_ADHOC_SUCCESS = 'SAVE_PROVIDER_REQUEST_ADHOC_SUCCESS';
export const SAVE_PROVIDER_REQUEST_ADHOC_FAILURE = 'SAVE_PROVIDER_REQUEST_ADHOC_FAILURE';

export const SCHEDULE_REQUEST_TRANSACTION_REQUEST = 'SCHEDULE_REQUEST_TRANSACTION_REQUEST';
export const SCHEDULE_REQUEST_TRANSACTION_SUCCESS = 'SCHEDULE_REQUEST_TRANSACTION_SUCCESS';
export const SCHEDULE_REQUEST_TRANSACTION_FAILURE = 'SCHEDULE_REQUEST_TRANSACTION_FAILURE';

export const SET_PROVIDER_REQUEST_FILTERS = 'SET_PROVIDER_REQUEST_FILTERS';
